import axios from 'axios'

import { unique } from '@/helpers/api'
import type { PageNumberPagination, UUID } from '@/types'
import type { TranscriptionEntity } from '@/types/entity'

import type { PageNumberPaginationParameters } from '.'

interface TranscriptionEntityListParameters extends PageNumberPaginationParameters {
  worker_run?: UUID | false
  worker_version?: UUID | false
}

// List all entities linked to a transcription
export const listTranscriptionEntities = unique(
  async (
    id: UUID,
    params: TranscriptionEntityListParameters = {},
  ): Promise<PageNumberPagination<TranscriptionEntity>> =>
    (await axios.get(`/transcription/${id}/entities/`, { params })).data,
)
